import { Head, Link } from '@inertiajs/react';
import { AttendeesList } from '@/components/attendees/attendees-list';
import type { HackerAttendeesShow } from '@/types';

// /:event_slug/hacker/attendees — the on-site directory inside the hacker portal, which
// Bogotá and Caracas ship. The roster only unlocks once the hacker has filled the feedback in.
export default function Show({
  title,
  eventName,
  feedbackSubmitted,
  feedbackPath,
  attendees,
}: HackerAttendeesShow) {
  return (
    <>
      <Head title={title} />
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-12 md:py-16">
          <div className="mx-auto w-full max-w-5xl space-y-8">
            <div>
              <h1 className="font-bold text-3xl text-primary sm:text-4xl">
                Asistentes
              </h1>
              <p className="mt-2 font-mono text-primary/70 text-sm">
                {eventName}
              </p>
            </div>

            {feedbackSubmitted ? (
              <AttendeesList attendees={attendees} />
            ) : (
              <div className="border-2 border-primary bg-background/80 p-6 backdrop-blur-sm sm:p-8">
                <p className="text-primary/70 text-sm sm:text-base">
                  Para ver la lista de asistentes, necesitamos que completes tu
                  feedback de {eventName}.
                </p>
                <Link
                  href={feedbackPath}
                  className="mt-4 inline-block bg-primary px-6 py-3 font-bold text-background transition-all hover:scale-105"
                >
                  Completar feedback
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
